/**
 * Compose a CSS color from a hex string and an alpha, for the text layer's
 * background box (`backgroundColor` + `backgroundOpacity`). The opacity must
 * apply to the box only — putting it on the element would fade the text too.
 *
 * Non-hex input is returned untouched so callers can pass `transparent` or an
 * already-composed color through.
 */
export function hexToRgba(hex: string, alpha: number): string {
  const match = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(hex.trim());
  if (!match) return hex;

  let body = match[1];
  if (body.length === 3) body = body.split('').map((c) => c + c).join('');

  const r = parseInt(body.slice(0, 2), 16);
  const g = parseInt(body.slice(2, 4), 16);
  const b = parseInt(body.slice(4, 6), 16);
  const a = Math.min(1, Math.max(0, Number.isFinite(alpha) ? alpha : 1));

  return `rgba(${r}, ${g}, ${b}, ${a})`;
}
